import { Mixpanel } from './mixpanel';
import { Ga } from './ga';
import { GA_TOKEN } from '../api/constants';
import { MyProfileResponse } from '../api/fetchMyProfile';

const TRACKING_PLATFORMS: ITracking[] = [Mixpanel];

if (GA_TOKEN) {
    TRACKING_PLATFORMS.push(Ga);
}

export const SELECT = 'SELECT';
export const PX_TIME = 'PX_TIME';
export const TRACK_ROUTE_MISSING = 'TRACK_ROUTE_MISSING';

export const SYMPTOM = 'symptom';
export const VITAL = 'vital';
export const DIAGNOSIS = 'diagnosis';
export const LAB_TEST = 'lab_test';
export const DRUG = 'drug';

export const CHANNEL_SUGGESTION = 'suggestion';
export const CHANNEL_SA = 'sa';
export const CHANNEL_GENIE = 'genie';
export const CHANNEL_ASSOCIATED = 'associated';
export const CHANNEL_SUGGESTED = 'suggested';
export const CHANNEL_COMPLEMENTARY = 'complementary';

export interface ITracking {
    initTracking: () => void;
    setTrackingIdentify: (profile: MyProfileResponse) => void;
    resetTracking: () => void;
    track: (name: string, params?: { [k: string]: string | undefined }) => void;
    timeTrackStart: (name: string) => void;
}

const trackingHandler: ITracking = {
    initTracking() {
        TRACKING_PLATFORMS.forEach((t) => {
            t.initTracking();
        });
    },

    setTrackingIdentify(profile) {
        TRACKING_PLATFORMS.forEach((t) => {
            t.setTrackingIdentify(profile);
        });
    },

    resetTracking() {
        TRACKING_PLATFORMS.forEach((t) => {
            t.resetTracking();
        });
    },

    track(name, params) {
        TRACKING_PLATFORMS.forEach((t) => {
            t.track(name, params);
        });
    },

    timeTrackStart(name: string) {
        TRACKING_PLATFORMS.forEach((t) => {
            t.timeTrackStart(name);
        });
    },
};

export const {
    track,
    resetTracking,
    initTracking,
    setTrackingIdentify,
    timeTrackStart,
} = trackingHandler;
